import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
import posthog from "posthog-js";
import { v4 as uuidv4 } from "uuid";

// @material-ui/core components
import { withStyles } from "@mui/styles";

// core components
// import PagesHeader from "components/Header/PagesHeader.jsx";
import PagesHeader from "../components/header.jsx";
// import Footer from "components/Footer/Footer.jsx";
import visitRoutes from "../routes/visits.js";

import pagesStyle from "~/shared/styles/defaultPageStyle.js";

import VisitVisioptTracking from "../components/visitVisioptTracking.jsx";

// import bgImage from "assets/img/register.jpeg";

class Pages extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(props.location.search);
    const checkoutSessionID = queryParams.get("checkoutSessionID");
    if (!checkoutSessionID) {
      const checkoutSessionID = uuidv4();
      // add checkoutSessionID to the url
      const url = new URL(window.location.href);
      url.searchParams.set("checkoutSessionID", checkoutSessionID);
      window.location.href = url.toString();
      return;
    }
  }

  componentDidMount() {
    document.body.style.overflow = "unset";
  }

  componentDidUpdate() {
    posthog.capture("$pageview");
  }

  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <VisitVisioptTracking />
        <PagesHeader {...rest} />
        <div className={classes.wrapper} ref="wrapper">
          <Switch>
            {visitRoutes.map((prop, key) => {
              if (prop.collapse) {
                return null;
              }
              if (prop.redirect) {
                return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
              }
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
        </div>
      </div>
    );
  }
}

Pages.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(pagesStyle)(Pages);

// style={{ backgroundImage: "url(" + bgImage + ")" }}

// <div className={classes.fullPage}>
